import { Component, Input, Output, EventEmitter, Injector, OnInit } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppComponentBase } from '@shared/app-component-base';
import { CustomCommon } from '@shared/custom-common/custom-common';

@Component({
    selector: 'select-multi-dropdown',
    templateUrl: './select-multi-dropdown.component.html'
})
export class SelectMultiDropdownComponent extends AppComponentBase implements OnInit {
    @Input() placeholder: string;
    @Input() data: any;
    @Input() idField: string;
    @Input() textField: string;
    @Input() inputModel: any;
    @Input() disabled: boolean;
    @Input() required: boolean;
    @Input() itemsShow: number;
    @Output() inputModelChange = new EventEmitter<string>();
    @Output() valid = new EventEmitter();
    dropdownSettings: IDropdownSettings;
    showMessageError: boolean;
    firstLoad: number;
    constructor(injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        if (this.placeholder == undefined) {
            this.placeholder = CustomCommon.ChooseOneValue;
        }
        if (this.idField == undefined) {
            this.dropdownSettings = {
                singleSelection: false,
                idField: CustomCommon.MasterListCode,
                textField: CustomCommon.MasterListCdeName,
                itemsShowLimit: this.itemsShow ?? 1,
                allowSearchFilter: true,
                searchPlaceholderText: this.l(CustomCommon.SearchWithThreeDot),
                noDataAvailablePlaceholderText: this.l(CustomCommon.NoDataAvailable),
                noFilteredDataAvailablePlaceholderText: this.l(CustomCommon.NoDataAvailable),
                selectAllText: this.l(CustomCommon.SelectAll),
                unSelectAllText: this.l(CustomCommon.UnSelectAll)
            };
        }
        else {
            this.dropdownSettings = {
                singleSelection: false,
                idField: this.idField,
                textField: this.textField,
                itemsShowLimit: this.itemsShow ?? 1,
                allowSearchFilter: true,
                searchPlaceholderText: this.l(CustomCommon.SearchWithThreeDot),
                noDataAvailablePlaceholderText: this.l(CustomCommon.NoDataAvailable),
                noFilteredDataAvailablePlaceholderText: this.l(CustomCommon.NoDataAvailable),
                selectAllText: this.l(CustomCommon.SelectAll),
                unSelectAllText: this.l(CustomCommon.UnSelectAll)
            };
        }

        this.showMessageError = false;
        this.firstLoad = 0;
    }

    inputModelChangeEvent(event) {
        this.inputModelChange.emit(event);
        if (this.required === true) {
            if (event === undefined || event.length === 0) {
                this.showMessageError = true
            }
            else {
                this.showMessageError = false;
            }
            this.valid.emit(this.showMessageError); 
            if(this.firstLoad < 2)
            {
                this.showMessageError = false;
                this.firstLoad++;
            }
        }
        else {
            this.showMessageError = false;
        }
    }
}
